<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
  },
  data () {
    return {
      proposta: null,
      listBase: [],
      assinaCCB: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          const validaNomeCliente = (this.cliente?.Nome || '').substring(0, 45)
          const nomeCliente = validaNomeCliente.length >= 45 ? validaNomeCliente + '...' : validaNomeCliente
          const tipo = this.$api.UI.Format.SomenteAlfanumerico(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj'
          if (el[tipo]) {
            return {
              text: el.papel.replace('@EMITENTENOME', nomeCliente).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal),
              value: el.papel.replace('@EMITENTENOME', nomeCliente).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal)
            }
          }
        })
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    },
  },
  methods: {
    async submit () {
      const th = this;
      const nomeConjuge = th.nomeConjuge
      const assinanteDto = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      const arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        await th.removerAssinantes();
      }

      if (arrayInclusao.length > 0) {
        th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: nomeConjuge ? `${assinanteDto.Nome} - CÔNJUGE DE ${nomeConjuge}` : assinanteDto.Nome,
              Email: assinanteDto.Email,
              Documento: assinanteDto.DocumentoFederal,
              TelefoneCelular: assinanteDto.TelefoneCelular,
              Descricao: papel,
              NotificarPorEmail: th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura),
              DtLimiteAssinatura: th.$api.UI.Date.AddDay(new Date(), 10)
            }
          })

          th.$api.Multiplo.Post('InsertCCBDigitalAssinaturas', { dto: arrayInclusao }).then(resInsert => {
            if (th.$api.UI.PostLoadData(resInsert, true)) { };
          });
        })
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteAlfanumerico(th.assinante.DocumentoFederal)));
          th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = []
      } else {
        th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
      }
    },
    async removerAssinantes () {
      const th = this;
      th.assinaCCB = false;
      th.model = {};

      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      arrayExclusao = arrayExclusao.map(papel => {
        return papel.Codigo
      })

      await th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', { dto: arrayExclusao });
    }
  },
}
</script>
<style scoped>
</style>
